import React from 'react'

import { Typography } from '@caudena/core/ui-kit'
import { RowDeprecated } from '@caudena/core/ui-kit'
import { ReactComponent as ShieldExclamationIcon } from '@caudena/core/assets/shield_exclamation.svg'

import CaseActivityCard from './index'
import { FeedRuleUpdateActivity } from '../../../../types/Case'
import { SnakeToCamelCaseObject } from '@caudena/core/utilsTypes'

interface CaseRuleUpdateActivityCardProps {
  activity: SnakeToCamelCaseObject<FeedRuleUpdateActivity>
  className?: string
}

const CaseRuleUpdateActivityCard: React.FC<CaseRuleUpdateActivityCardProps> = ({
  activity,
  className,
}) => {
  return (
    <CaseActivityCard
      className={className}
      icon={<ShieldExclamationIcon />}
      title="Rule update"
      main={
        <Typography variant="body3" color="grey2">
          <RowDeprecated gap={0.5}>
            <Typography color="grey2">{activity.activity.text}</Typography>
          </RowDeprecated>
        </Typography>
      }
      date={new Date(activity.insertedAt)}
    />
  )
}

export default CaseRuleUpdateActivityCard
